var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.label && _vm.config.showLabel)?_c('FormLabel',_vm._b({},'FormLabel',{
      label: _vm.label,
      required: _vm.required,
      disabled: _vm.disabled,
      description: _vm.description,
      descriptionType: _vm.descriptionType,
      dirty: _vm.dirty,
      error: _vm.error,
      id: _vm.id,
      status: _vm.status
    },false)):_vm._e(),_c('FormArrayValidationGroup',{on:{"validation":function($event){return _vm.$emit('validation', $event)}},scopedSlots:_vm._u([{key:"default",fn:function(ref){
    var updateValidation = ref.updateValidation;
    var nestedValidationsByIndex = ref.nestedValidationsByIndex;
return [_c('FormList',{ref:"list",attrs:{"value":_vm.value,"disabled":_vm.disabled,"validation":nestedValidationsByIndex},on:{"input":function($event){return _vm.$emit('input', $event)}},scopedSlots:_vm._u([{key:"default",fn:function(ref){
    var isRead = ref.isRead;
    var isEdit = ref.isEdit;
    var item = ref.item;
    var index = ref.index;
    var updateItem = ref.updateItem;
return [_c('SchemaForm',{attrs:{"disabled":_vm.disabled || isRead,"value":item,"fields":_vm.fields,"validation":true,"dirtyOn":"blur"},on:{"validation":function($event){
    var i = arguments.length, argsArray = Array(i);
    while ( i-- ) argsArray[i] = arguments[i];
return updateValidation.apply(void 0, [ index ].concat( argsArray ))},"input":function($event){return updateItem(index, $event)}}})]}}],null,true)})]}}])}),(!_vm.disabled)?_c('AppButton',{on:{"click":_vm.add}},[_c('AppIcon',{attrs:{"name":"add"}}),_c('span',[_vm._v("Add new contact")])],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }